import type { SdkQuizQuestionModel } from '../question-model';
import { SdkGameEvent } from '@/src/sdk/events/gameEvent';

export class SdkQuizQuestionDisplayEvent extends SdkGameEvent {
  constructor(public readonly question: SdkQuizQuestionModel) {
    super();
  }
}
